export default "__VITE_ASSET__CSZeYEOy__"